import React from 'react';
import TrackVisibility from 'react-on-screen';

import config from '@config';

const ChannelList = ({ channels }) => (
  <ul className="tvg-channel-list">
    {channels.map((c, i) => (
      <TrackVisibility
        offset={config.visibilityTrackingOffset}
        partialVisibility
        key={c.service_id}
        tag="li"
      >
        {({ isVisible }) =>
          isVisible && (
            <div>
              <span>{c['logical_channel_number']}</span>
              <img
                src={`${c.service_image}?w=${config.channelImageWidth}`}
                loading="lazy"
              />
            </div>
          )
        }
      </TrackVisibility>
    ))}
  </ul>
);

export default ChannelList;
